export default __webpack_public_path__ + "static/notosans-bold-webfont-63e087cd1016685cc41d0bb92f874403.woff";